import { createSelector } from 'reselect';
import { percentOffFlagSaleSelector } from 'selectors/testTarget/offers/percentOffFlagSale/percentOffFlagSaleSelector';

const showSelector = createSelector(percentOffFlagSaleSelector, percentOffFlagSale => !!percentOffFlagSale.show);

export { showSelector };
